<template>
  <tr>
    <th
      v-for="header in headers"
      :key="header.text"
      :class="{
        'column': true,
        'text-xs-left': header.align === 'left' || !header.align,
        'text-xs-center': header.align === 'center',
        'text-xs-right': header.align === 'right',
        'sortable': header.sortable,
        'desc': paginacion.descending,
        'asc': !paginacion.descending,
        'active': header.value === paginacion.sortBy
      }"
      @click="changeSort(header)"
    >
      <v-icon
        small
        v-show="header.sortable"
      >arrow_upward</v-icon>
      {{ header.text }}
    </th>
    <th class="text-xs-right">
      <slot></slot>

    </th>
  </tr>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default () {
        return []
      }
    },
    paginacion: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    changeSort (column) {
      if (column.sortable) {
        if (this.paginacion.sortBy === column.value) {
          this.paginacion.descending = !this.paginacion.descending
        } else {
          this.paginacion.sortBy = column.value
          this.paginacion.descending = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
